import { useParams } from "react-router";

import { useReportNavigation } from "../../hooks/use-report-navigation.ts";
import { ShipmentDetailsReport } from "../shipment-details-report/shipment-details-report.tsx";
import { ReportDetail } from "./report-detail.tsx";

const REPORT_CONFIG: Record<string, { title: string }> = {
	"shipment-details": { title: "Shipment Details Report" },
};

export function ReportDetailPage() {
	const { reportId } = useParams<{ reportId: string }>();

	const config = reportId ? REPORT_CONFIG[reportId] : undefined;

	const { activeCustomer, isCustomerLoading, handleSelectCustomer } =
		useReportNavigation(reportId ?? "shipment-details");

	if (!config) {
		return (
			<ReportDetail
				onCustomerChange={handleSelectCustomer}
				selectedCustomer={activeCustomer}
				title={"Report Not Found"}
			>
				<p>The requested report could not be found.</p>
			</ReportDetail>
		);
	}

	return (
		<ReportDetail
			onCustomerChange={handleSelectCustomer}
			selectedCustomer={activeCustomer}
			title={config.title}
		>
			{(mobileHeader) =>
				reportId === "shipment-details" && (
					<ShipmentDetailsReport
						customerId={activeCustomer?.id}
						isCustomerLoading={isCustomerLoading}
						mobileHeader={mobileHeader}
					/>
				)
			}
		</ReportDetail>
	);
}
